/* global Swiper */

export const siteIsLanding = () => /\/catalog\/\w{2}\/companies\/\d+\/\b/.test(window.location.pathname)

export const messageWithCountry = (message, replacement) => {
  return message.replace(/\{\{country\}\}/, replacement);
};

export const showAlert = (container, message, isError = false, scrollToAlert = false) => {
  if (!container && !message) return;
  hideAlerts(container);
  const messageContainer = container.querySelector('.js-message-feedback');
  const messageSelector = messageContainer.querySelector('.js-inner-message');
  messageSelector.innerHTML = message;
  messageContainer.classList.add(isError ? 'afd-message--error' : 'afd-message--success');
  messageContainer.classList.remove('afd-hide');
  if (scrollToAlert) messageContainer.scrollIntoView({ behavior: 'smooth', block: 'center' });
}

export const hideAlerts = container => {
  var alerts = container ? container.querySelectorAll('.js-message-feedback') : document.querySelectorAll('.js-message-feedback');
  alerts.forEach(alert => {
    alert.classList.add('afd-hide');
    alert.classList.remove('afd-message--success', 'afd-message--error');
  });
}

export const initProductImagesSwiper = () => {
  NFT.swipers = NFT.swipers || {}
  NFT.swipers['productImages'] = new Swiper('.product-images.swiper-container', {
    preloadImages: false,
    nested: true,
    slidesPerView: 1,
    spaceBetween: 0,
    noSwiping: false,
    noSwipingClass: 'product-images',
    lazy: {
      loadPrevNext: true,
      loadOnTransitionStart: true,
      preloaderClass: 'preloader-container'
    },
    pagination: {
      el: '.swiper-pagination.product-images__pagination',
      clickable: true
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        spaceBetween: 0,
        noSwiping: true
      }
    }
  })
  // Custom navigation logic due to issue with swiper loop
  document.querySelectorAll('.product-images__nav')
    .forEach(navBtn => {
      const currentSwiper = navBtn.closest('.product-images.swiper-container').swiper;
      const lastItem = currentSwiper.slides.length - 1;
      navBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (this.matches('.product-images__nav--prev')) {
          return currentSwiper.isBeginning ? currentSwiper.slideTo(lastItem) : currentSwiper.slidePrev();
        } else if (this.matches('.product-images__nav--next')) {
          return currentSwiper.isEnd ? currentSwiper.slideTo(0) : currentSwiper.slideNext();
        }
      });
    });
};

export const initSimilarProductsSwiper = () => {
  const swiperContainer = document.querySelector('.products-swiper');
  const loadingContainer = document.getElementById('js-similar-products-loading');
  const productsFallback = document.getElementById('js-fallback-products');
  const productContainers = document.querySelectorAll('.swiper-slide.bir-product') || [];

  if (!productContainers.length) {
    loadingContainer.classList.add('afd-hide');
    productsFallback.classList.remove('afd-hide');
    return;
  }

  NFT.swipers = NFT.swipers || {}
  NFT.swipers['similarProducts'] = new Swiper('.products.swiper-container', {
    loop: productContainers.length > 3,
    watchOverflow: true,
    slidesPerView: 3,
    spaceBetween: 40,
    updateOnImagesReady: true,
    navigation: {
      prevEl: '.products-swiper__nav.products-swiper__nav--prev',
      nextEl: '.products-swiper__nav.products-swiper__nav--next'
    },
    on: {
      imagesReady: function () {
        swiperContainer.classList.remove('afd-hide');
        loadingContainer.classList.add('afd-hide');
        this.update();
      }
    },
    breakpoints: {
      480: {
        slidesPerView: 'auto',
        spaceBetween: 24
      },
      767: {
        slidesPerView: 3,
        spaceBetween: 40
      }
    }
  });
};